import { initialize } from "@open-iframe-resizer/core";

initialize({}, '.jsOpenIframeResizer');